import { combineReducers } from 'redux'

import { makeCommunicationReducer } from 'shared/utils/communication/reducer/makeCommunicationReducer'

import { IWheelGameState } from '../types'
import * as actions from '../actions'

export default combineReducers<IWheelGameState['communications']>({
  getSpinHistory: makeCommunicationReducer(actions.getSpinHistory),
  getPrizesList: makeCommunicationReducer(actions.getPrizesList),
  getPublicSettings: makeCommunicationReducer(actions.getPublicSettings),
  spinWheel: makeCommunicationReducer(actions.spinWheel),
})
